import { Button } from '@ui/lib/park/ui/button';
import { Field } from '@ui/lib/park/ui/field';
import { isEmpty } from 'lodash-es';
import { useTranslation } from 'next-i18next';
import { Box, BoxProps, Flex } from 'styled-system/jsx';

import { useTradePairSearchStore } from './hooks/useTradePairSearchStore';

export const MassiveTokenSearch = ({
  fieldRootProps,
  fieldInputProps,
  ...props
}: BoxProps & {
  fieldRootProps?: Field.RootProps;
  fieldInputProps?: Field.InputProps;
}) => {
  const { t } = useTranslation();

  const setSearchString = useTradePairSearchStore((s) => s.setSearchString);
  const searchString = useTradePairSearchStore((s) => s.searchString);
  const clearSearch = useTradePairSearchStore((s) => s.clearSearch);

  return (
    <Box data-cy="Token-Search" {...props}>
      <Field.Root {...fieldRootProps}>
        <Flex alignItems="center">
          <Field.Input
            value={searchString}
            placeholder={t('common.Search For Assets')}
            w="full"
            onChange={(nextValue) => {
              setSearchString(nextValue.target.value);
            }}
            type="text"
            {...fieldInputProps}
            data-cy="Token-Search-Input"
          />
          <Field.Label
            pr={2}
            visibility={!isEmpty(searchString) ? 'visible' : 'hidden'}
          >
            <Button
              variant="text"
              color="greyWhite.lightGrey3"
              onClick={() => clearSearch()}
            >
              {t('common.Clear')}
            </Button>
          </Field.Label>
        </Flex>
      </Field.Root>
    </Box>
  );
};
